import { TripsPageQuery } from '@website/types/graphqlOperations';
import Head from 'next/head';
import type { FAQPage, Product, WithContext } from 'schema-dts';
import { openGraphImage } from '../../media/utils/imgix';

export default function TripSchemaMarkup({
  trip,
}: {
  trip: TripsPageQuery['tripByURL'];
}) {
  const product: WithContext<Product> = {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: trip.title,
    description: trip.description,
    image: trip.image.file ? [openGraphImage(trip.image.file.key, {})] : [],
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: trip.reviewsSummary.fiveStarRatingAverage,
      reviewCount: trip.reviewsSummary.reviewCount,
    },
    review: trip.reviews.items.map((review) => ({
      '@type': 'Review',
      reviewRating: {
        '@type': 'Rating',
        ratingValue: review.fiveStarRating,
      },
      author: {
        '@type': 'Person',
        name: review.user.givenName,
      },
      reviewBody: review.body,
    })),
  };

  const faqPage: WithContext<FAQPage> = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: trip.faqs.items.map((faq) => ({
      '@type': 'Question',
      name: `${faq.question}?`,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <Head>
      <script type="application/ld+json">{JSON.stringify(product)}</script>
      <script type="application/ld+json">{JSON.stringify(faqPage)}</script>
    </Head>
  );
}
